module.exports = __webpack_public_path__ + "img/logo.b3993ee1.png";